import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { RiRadioButtonFill } from "react-icons/ri";
import { BsFiletypeDocx, BsFiletypeXlsx, BsFiletypePdf } from "react-icons/bs";

import { AppContext } from "../../Context";
import Popups from "../../components/Pop";
import Fetch, { Loader } from "../../inc/Fetch";
import "../css/SelectSchool.css";
import { Config } from "../../inc/Config";
import { MdOutlineCloudDownload } from "react-icons/md";

export default function TaskNotes() {
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [loading, setloading] = useState(false);

    return (
        <>
            {loading && <Loader />}
            <Popups style={{ maxWidth: 650 }}>
                <h1>{t("tasks_send_notes")}</h1>

                <div
                    className="popupBody "
                    style={{ padding: 20, whiteSpace: "pre-line" }}
                >
                    <div
                        style={{ padding: 15 }}
                        dangerouslySetInnerHTML={{
                            __html: location?.state?.notes,
                        }}
                    />
                </div>
            </Popups>
        </>
    );
}
